<template>
  <div class="album-list maxW">
    <CommonCate @changeCateOption="changeCateOption" @changeOrderType="changeOrderType" />
    <!-- <ItcCate @emitListData="getListData" v-if="false" />
    <div class="album-cate" v-if="false">
      <div class="cate-left">{{ $t('homepage.resource_cate') }}：</div>
      <div class="cate-right">
        <ul>
          <li v-for="item in cateList" @click="selectCate(item.id)" :key="item.id">
            <span :class="activeClass == item.id ? 'cate-active' : ''">{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <br style="clear:both;" />
    </div> -->

    <!-- <div class="carousel-part clear">
      <div class="caurse-carousel fl">
        <template>
          <el-carousel :interval="5000" height="400px">
            <el-carousel-item v-for="(item, index) in carouselPicData" :key="index">
              <a :href="item.link_url" target="_blank" v-if='item.link_url'>
                <img :src="BASE_URL + item.picture">
              </a>
              <a v-else> <img :src="BASE_URL + item.picture"> </a>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
      <div class="popularity-list fr">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="humantitle">{{ $t('homepage.popularity') }}</span>
          </div>
          <div v-for="(item, index) in humanQiData" :key="index" class="text item humanItem">
            <i :class="[(index + 1) < 4 ? 'humanNun yellowC' : 'humanNun']">{{ index + 1 }}</i>
            <router-link :to="{ path: 'albumDetail', query: { id: item.albumid } }" :title="item.name">
              {{ item.name }}
            </router-link>
          </div>
          <div class="dependent1" v-if="placeholder1">
            <i class="ipng image_state01"></i>
            <p>{{ $t('global.noData') }}</p>
          </div>
        </el-card>
      </div>
    </div> -->
    <div class="album-list-box ">
      <!-- <div class="filter-nav album">
        <el-button type="text" :class="[orderType == 'time' ? 'blueC' : '']" @click="toggle_order('time')">
          {{ $t('homepage.time') }}<i class="el-icon-sort-down"></i>
        </el-button>
        <el-button type="text" :class="[orderType == 'hot' ? 'blueC' : '']" @click="toggle_order('hot')">
          {{ $t('homepage.heat') }}<i class="el-icon-sort-down"></i>
        </el-button>
      </div> -->
      <ul>
        <li class="i_groupLs_album box" v-for="(item, index) of albumListData" :key="index">
          <div class="i_groupLs_album_img">
            <router-link :to="{ path: 'albumDetail', query: { id: item.albumid } }">
              <img :src="BASE_URL + item.picture" :onerror="errorImg">
            </router-link>
          </div>
          <div class="i_groupLs_album_if">
            <div class="i_groupLs_album_info clear">
              <router-link :to="{ path: 'albumDetail', query: { id: item.albumid } }" :title="item.name">
                {{ item.name }}
              </router-link>
              <div class="schoolInfo clear">
                <a href="javascript:;">
                  <!-- :src="BASE_URL + item.avatar_path" -->
                  <!-- <img class="acatar_img" src="../../../assets/images/morentouxiang.png"> -->
                  <img class="acatar_img" :src="item.avatar_path">
                  <!-- <div class="red_dot" v-if="item.is_update" /> -->
                  <span>{{ item.custom_speaker }}</span>
                  <span class="cate" :title="item.cate_name ? item.cate_name : $t('global.defaultSort')">{{ item.cate_name
                    ? item.cate_name : $t('global.defaultSort') }}</span>
                </a>
              </div>
            </div>
          </div>

          <svg t="1704338388143" 
          <svg t="1704338200517" class="red_dot" v-if="item.is_update"  viewBox="0 0 1265 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="39382" width="51" height="51"><path d="M374.894 536.327c0 0.004 0 0.018 0 0.023 0 183.665 148.891 332.559 332.559 332.559 183.665 0 332.559-148.891 332.559-332.559 0-0.005 0-0.019 0-0.023 0-0.003 0-0.017 0-0.022 0-183.665-148.891-332.559-332.559-332.559-183.665 0-332.559 148.891-332.559 332.559 0 0.005 0 0.019 0 0.023z" fill="#f1cdc8" p-id="39383"></path><path d="M496.886 536.327c0 116.292 94.271 210.564 210.564 210.564s210.564-94.271 210.564-210.564c0 0 0 0 0 0 0-116.292-94.271-210.564-210.564-210.564-116.292 0-210.564 94.271-210.564 210.564 0 0 0 0 0 0z" fill="#d81e06" p-id="39384"></path></svg>
     
        </li>
      </ul>
      <div class="pageBox">
        <el-pagination v-if="total_number > page_size" @current-change="change_page" :page-size="page_size"
          :current-page="page_index" layout="total,prev, pager, next,jumper" :total="total_number">
        </el-pagination>
      </div>
      <div class="dependent" v-if="placeholder">
        <i class="ipng image_state01"></i>
        <p>{{ $t('global.noData') }}</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      placeholder: false,
      placeholder1: false,
      page_index: 1,
      page_size: 12,
      total_number: 0,
      orderType: "time",
      study_section_id: 0,
      grade_id: 0,
      subject_id: 0,
      version_id: 0, // 版本
      keyword: this.$route.query.keyword, //首页搜索跳转到此页面时带的关键字
      create_id: 0,
      orgList: [],
      orgLevel3: [],
      subjectList: [],
      errorImg:
        'this.src="' +
        require("../../../../public/images/image_loding.png") +
        '"',
      checked: false,
      subjectChecked: 0,
      gradeChecked: 0,
      orgChecked: 0,
      albumListData: [],
      carouselPicData: [],
      humanQiData: [],
      // cateList: [], //专辑分类
      activeClass: 0,
      cate_id: 0,
    };
  },
  components: {
    ItcCate: () => import("../itcComponents/cateOptions.vue"),
    CommonCate: () => import("@/components/common-v2/category.vue"),
  },
  created() {
    // this.getOrg();
    // this.getCarouselPic();
    this.getAlbumData();
    // this.humanQi();
    // this.getAlumCate();
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
  },
  mounted() {
    // this.getCarouselPic();
  },
  watch: {
    gradeChecked(a, b) {
      if (a != b) {
        this.page_index = 1;
      }
    },
    "$route.query.keyword"(value) {
      this.keyword = value;
        this.page_index = 1;
        this.getAlbumData();
    },
  },
  methods: {
    changeCateOption(cateOptions) {
      let val = 0
      for (const key in cateOptions) {
        if (cateOptions[key]) {
          val = cateOptions[key]
        }
      }
      this.cate_id = val;
      this.activeClass = val;
      this.getAlbumData();
    },
    getListData(val) {
      this.cate_id = val;
      this.activeClass = val;
      this.getAlbumData();
    },
    //获取专辑分类
    getAlumCate() {
      let success = (res) => {
        this.cateList = [
          { id: 0, name: this.$t("global.all") },
          { id: -1, name: this.$t("global.defaultSort") },
        ].concat(res.data);
      };
      this.$ajax({
        url: "api/video/video_cate",
        method: "get",
        params: {
          status: 1,
        },
        func: {
          success: success,
        },
      });
    },
    //点击分类筛选固定分类
    selectCate(id) {
      this.cate_id = id;
      this.activeClass = id;
      this.getAlbumData();
    },
    getAlbumData() {
      let success = (res) => {
        // console.log(res)
        this.albumListData = res.data.data;
        this.albumListData.forEach((item) => {
          if (
            item.avatar_path.includes("/static/default/user_preview-1.png") ||
            item.avatar_path.includes("/public/picture")
          ) {
            item.avatar_path = this.BASE_URL + item.avatar_path;
          }
        });
        this.total_number = res.data.data_sum;
        res.data.data.length == 0
          ? (this.placeholder = true)
          : (this.placeholder = false);
      };
      let params = {
        flag: "home",
        order_type: this.orderType,
        page_index: this.page_index,
        page_size: this.page_size,
        study_section_id: this.study_section_id,
        grade_id: this.grade_id,
        subject_id: this.subject_id,
        keyword: this.keyword,
        cate_id: this.cate_id,
        is_limit: 1,
        user_id: this.$g.user_id
      };
      this.$ajax({
        url: "api/albumcompany/albums_list",
        method: "get",
        params,
        func: {
          success: success,
        },
      });
    },
    //轮播图
    getCarouselPic() {
      let success = (res) => {
        this.carouselPicData = deep_clone(res.data);
      };
      this.$ajax({
        url: "api/carousel/banners",
        method: "get",
        params: {
          module: 3,
        },
        func: {
          success: success,
        },
      });
    },
    //人气
    humanQi() {
      let success = (res) => {
        this.humanQiData = res.data.data;
        res.data.data.length == 0
          ? (this.placeholder1 = true)
          : (this.placeholder1 = false);
      };
      let params = {
        flag: "home",
        page_index: 1,
        page_size: 10,
        order_type: "hot",
      };
      this.$ajax.get("api/albumcompany/albums_list", {
        params,
        func: {
          success: success,
        },
      });
    },
    changeOrderType(type) {

      this.orderType = type;
      this.getAlbumData();
    },
    //获取学段
    getOrg() {
      let params = {
        level: 2,
        pid: 1,
        direction: "balance",
        is_diffplat: 1,
      };
      const success = (res) => {
        // console.log(res)
        this.orgList = res.data;
        this.orgList.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.getOrgLevel3(this.orgList[0].id);
        this.getAlbumData();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    //获取年级
    getOrgLevel3(index, study_section_id) {
      this.orgChecked = index;
      let params = {
        level: 3,
        pid: study_section_id == 0 ? undefined : study_section_id,
        direction: "balance",
      };
      const success = (res) => {
        this.orgLevel3 = res.data;
        this.orgLevel3.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.getSubjectList(this.orgLevel3[0].id);
        (this.study_section_id = study_section_id), this.getAlbumData();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    //获取学科
    getSubjectList(orgid, _index) {
      if (_index == undefined) {
        this.gradeChecked = 0;
      } else {
        this.gradeChecked = _index;
      }
      let params = {
        type: 2,
        subject_id: orgid === orgid ? orgid : null,
        status: 1,
      };
      const success = (res) => {
        this.subjectList = res.data;
        this.subjectList.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.grade_id = orgid;
        this.getAlbumData();
      };
      this.$ajax.get("api/cate/subject", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    subjectChange(index, id) {
      this.subjectChecked = index;
      this.subject_id = id;
      this.getAlbumData();
    },
    change_page(val) {
      this.page_index = val;
      this.getAlbumData();
    },
  },
};
</script>
<style lang="scss" scoped>
.album-cate {
  margin-top: 20px;
  padding-bottom: 20px;
  min-height: 50px;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #020202;
  line-height: 19px;



  .cate-left {
    padding: 25px;
    float: left;
    width: 6%;
  }

  .cate-right {
    width: 80%;
    float: left;

    ul li {
      display: inline-block;
      /*width: 11%;*/
      padding: 25px 50px 0 0;
      color: #666666;
      cursor: pointer;

      &:hover {
        color: #E62125;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .cate-active {
      color: #E62125;
    }
  }
}

.course-kard {
  padding: 20px 20px 13px 20px;
  background: #ffffff;
  margin: 0 0 40px;
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-top: 3px;
}

.course-content {
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 10px;
}

.course-content>span {
  display: block;
  float: left;
  color: #666666;
  width: 60px;
  overflow: hidden;
  height: 19px;
  text-align: left;
}

.course-content:last-of-type {
  margin-bottom: 0;
}

.course-list {
  margin-left: 60px;
  min-height: 29px;
}

.course-list>label {
  float: left;
  color: #000000;
  cursor: pointer;
  margin: 0 3.7735849057% 10px 0;
}

.course-list>label>input:checked+span {
  color: #E62125;
}

.course-list>label input {
  display: none;
}

.course-list>label:hover {
  color: #61a4f5;
}

.album-list {
  margin: auto;
  margin-top: 9%;
}

.album-list-box {
  margin: 20px 0 40px;
  margin: 0 0 40px;
  // .i_groupLs_album:hover {
  //     -webkit-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  //     -moz-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  //     box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  // }
}

.album-list-box>ul:after {
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  display: block;
  zoom: 1;
}

.i_groupLs_album .i_groupLs_album_if>a,
.i_groupLs_album .i_groupLs_album_if>p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.i_groupLs_album {
  float: left;
  width: 290px;
  height: 250px;
  border-radius: 3px;
  // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 0 13px 20px 0;
  background: #fff;
  position: relative;

  -moz-transition: all 0.35s ease-in;
  -webkit-transition: all 0.35s ease-in;
  -o-transition: all 0.35s ease-in;
  transition: all 0.35s ease-in;
}


.red_dot {
      width: 25px;
      height: 25px;
      right: 5px;
      top:5px;
      z-index: 99;
      position: absolute;
    }

// .i_groupLs_album:hover > .i_groupLs_album_if {
//     -webkit-transform: translate3d(0, -40px, 0);
//     -moz-transform: translate3d(0, -40px, 0);
//     transform: translate3d(0, -40px, 0);
// }
// .i_groupLs_album:hover .i_groupLs_album_info > a {
//     color: #E62125;
// }
// .i_groupLs_album:hover > .i_groupLs_album_img {
//     -webkit-transform: translate3d(0, -20px, 0);
//     -moz-transform: translate3d(0, -20px, 0);
//     transform: translate3d(0, -20px, 0);
// }
.i_groupLs_album .i_groupLs_album_img {
  height: 164px;
  display: block;
  overflow: hidden;
  transition: all 0.25s ease-in;
}

.i_groupLs_album .i_groupLs_album_img a,
.i_groupLs_album .i_groupLs_album_img img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}

.i_groupLs_album_img a {
  position: relative;
}

.i_groupLs_album_img a::after {
  content: "";
  opacity: 0;
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0.01) 2%,
      rgba(0, 0, 0, 0.2));
  transition: opacity 0.4s ease-in-out;
  position: absolute;
  top: 2px;
  left: 0;
  width: 100%;
  height: 164px;
}

.i_groupLs_album_img:hover>a:after {
  opacity: 1;
}

.i_groupLs_album .i_groupLs_album_if {
  padding: 0 10px 20px;
  background: #ffffff;
  transition: all 0.25s ease-in;
}

.i_groupLs_album .i_groupLs_album_if>a {
  font-size: 14px;
  color: #020202;
  line-height: 20px;
  padding-top: 13px;
  display: block;
  cursor: pointer;
}

// .i_groupLs_album .i_groupLs_album_if .i_groupLs_album:hover {
//     box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
// }
.i_groupLs_album:nth-of-type(4n) {
  margin: 0 0 18px 0;
}

.i_groupLs_album_info {
  margin-top: 15px;
  height: 25px;
  line-height: 25px;

  .i_sumBook {
    height: 30px;
    color: #888;
  }

  .acatar_img {
    display: inline-block;
    vertical-align: middle;
    width: 25px;
    height: 25px;
    -moz-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 5px;
  }

  .schoolInfo {
    margin-top: 10px;
    color: #4c8edc;
    position: relative;

    .red_dot {
      width: 7px;
      height: 7px;
      background-color: red;
      border-radius: 30px;
      left: -7px;
      top: -140%;
      z-index: 99;
      position: absolute;
    }

    // cursor: pointer;
    a {
      cursor: auto;

      .cate {
        display: block;
        width: 87px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e8e9e9;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #727e90;
        line-height: 24px;
        text-align: center;
        float: right;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap;
      }
    }

    i {
      margin: 0 5px;
    }
  }
}

.i_groupLs_album_info>a {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.course-kard {
  margin: 20px 0;
  overflow: hidden;
}

.carousel-part {
  padding-top: 40px;

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .el-carousel__button {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .caurse-carousel {
    display: inline-block;
    width: 860px;
    height: 400px;

    img {
      height: 100%;
    }
  }

  .el-carousel {
    border-radius: 3px;
  }

  .popularity-list {
    display: inline-block;
    width: 320px;
    background-color: #fff;

    .humantitle {
      // padding: 5px 8px;
      // border-radius: 2px;
      font-size: 14px;
      // color: #fff;
      // background-color: #338efc;
      color: #666;
      line-height: 18px;
    }

    .el-card__header {
      padding: 10px 17px 15px;
      // margin: 0 8px;
      border-bottom: solid 2px #e5e5e5;
      border-bottom: none;
    }

    .el-card__body {
      height: 299px;
      padding: 15px 20px 20px;
      padding: 0 17px;
      height: 355px;
    }

    .humanItem {
      padding: 5px 0;
    }

    .humanItem i {
      border-radius: 4px;
      vertical-align: middle;
    }

    .humanItem a {
      display: inline-block;
      width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 20px;
      font-size: 14px;
      color: #020202;
      vertical-align: middle;
    }

    .humanItem:hover {
      background-color: #effaff;
    }

    .humanItem:hover>a {
      color: #E62125;
    }

    .humanNun {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #ffffff;
      background: #d2d2d2;
      margin-right: 10px;
    }

    .humanNun.yellowC {
      background: #f2b732;
    }
  }
}

// .filter-nav.album {
//   display: inline-block;
//   padding: 10px;
//   margin-top: 20px;
//   margin-bottom: 20px;
//   background: #fff;
//   box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

//   .el-button {
//     line-height: 24px;
//     font-size: 14px;
//     color: #000;
//     color: #727272;
//     background: #fff;
//     padding: 3px 0;
//     width: 60px;
//     text-align: center;
//   }

//   .el-icon-sort-down {
//     margin-left: 5px;
//   }

//   .cut {
//     margin: 0 20px;
//     color: #d2d2d2;
//   }

//   .blueC {
//     color: #338efc;
//     color: #fff;
//     border-radius: 2px;
//     background: #E62126;
//   }

//   .el-button+.el-button {
//     margin-left: 5px;
//   }
// }

.dependent {
  background-color: #fff;
  text-align: center;
  overflow: hidden;
  margin-bottom: 50px;
  padding-top: 30px;

  p {
    color: #999;
    margin: 40px 0;
  }
}

.dependent1 {
  text-align: center;
  color: #999;

  i {
    margin: 30px 0;
  }
}
</style>
